export default __webpack_public_path__ + "static/survey-end-ede88c7366a96d86e3f913972bc66e95.jpg";